import { useAuth0 } from "@auth0/auth0-react";
import {
  Avatar,
  CssBaseline,
  Typography,
  Container,
  Card,
  CardContent,
} from "@mui/material";
import "@/components/Account/profile/Profile.css";

const Profile = () => {
  const { user, isAuthenticated } = useAuth0();

  return (
    isAuthenticated && (
      <Container component="main" maxWidth="xs">
        <CssBaseline />

        <Card sx={{ maxWidth: 345 }} id="profile-card">
          <CardContent>
            <Avatar alt={user.name} src={user.picture} />
            <Typography gutterBottom variant="h5" component="div">
              user info
            </Typography>

            <Typography variant="body1">Affiliate: {user.org_name} </Typography>
            <Typography variant="body1">Name: {user.name} </Typography>
            <Typography variant="body1">Email: {user.email} </Typography>
          </CardContent>
        </Card>
      </Container>
    )
  );
};

export default Profile;
